import {
  Avatar as ChakraUIAvatar,
  AvatarProps as ChakraUIAvatarProps,
  ComponentStyleConfig,
  StyleProps
} from "@chakra-ui/react";

export interface AvatarProps
  extends Pick<ChakraUIAvatarProps, "name" | "src" | "size">,
    StyleProps {}

const AvatarComponentStyle: ComponentStyleConfig = {
  baseStyle: {
    container: {
      background: "gray.300"
    },
    label: {
      color: "gray.700"
    }
  },
  sizes: {
    md: {
      container: {
        width: 10,
        height: 10
      },
      label: {
        fontSize: "sm"
      }
    },
    lg: {
      container: {
        width: 12,
        height: 12
      },
      label: {
        fontSize: "md"
      }
    },
    xl: {
      container: {
        width: 14,
        height: 14
      },
      label: {
        fontSize: "lg"
      }
    }
  }
};

function Avatar(props: AvatarProps) {
  return <ChakraUIAvatar {...props} />;
}

export { Avatar, AvatarComponentStyle };
